const sidebars = {  

   // SidebarMain
mainSidebar: {
  search: {
    galleryPlaceholder: '🔍 Galerie durchsuchen...',
    likesPlaceholder: '🔍 Meine Likes durchsuchen...',
    followingPlaceholder: '🔍 Meinen Feed durchsuchen...',
  },

  location: {
    tooltip:
      'Fordert den Zugriff auf deinen Gerätestandort an (Berechtigung erforderlich) und aktualisiert Inhalte in deiner Nähe.',
  },

  buttons: {
    gallery: 'Galerie',
    changeLocation: 'Standort ändern',
    myPreferences: 'Mein Feed',
    myLikes: 'Meine Likes',
    chat: 'Chat',
    myProfile: 'Mein Profil',
    settings: 'Einstellungen',
    upload: 'Beitrag hochladen',
    logout: 'Abmelden',
    ads: 'Werbung',
  },

  footer: {
    helpSupport: 'Hilfe & Support',
    privacyPolicy: 'Datenschutzerklärung',
    termsOfUse: 'Nutzungsbedingungen',
  },
},

// Sidebar My Profile
sidebarMyProfile: {
  buttons: {
    profile: 'Mein Profil',
    postings: 'Meine Beiträge',
    favorites: 'Beiträge, denen ich folge',
    followers: 'Follower',
    gallery: 'Galerie',
    notifications: 'Benachrichtigungen',
    myPreferences: 'Mein Feed',
    myLikes: 'Meine Likes',
    chat: 'Chat',
    settings: 'Einstellungen',
    logout: 'Abmelden',
  },

  sections: {
    profile: 'Profilverwaltung',
    noti: 'Benachrichtigungen',
    nav: 'Navigation',
    chat: 'Chat',
  },
},

// SidebarGalleryPosting
galleryPostingSidebar: {
  heading: 'Beitrag hochladen',
  buttons: {
    post: 'Veröffentlichen',
    cancel: 'Abbrechen',
  },
  leftLabel: '(Heute noch {{count}} übrig)',
},

// SidebarGalleryEditPosting
galleryEditSidebar: {
  heading: 'Beitrag bearbeiten',
  buttons: {
    save: 'Speichern',
    cancel: 'Abbrechen',
  },
},

// SettingsSidebar
settingsSidebar: {
  sections: {
    settings: 'Einstellungen',
    myProfile: 'Mein Profil',
    navigation: 'Navigation',
  },

  buttons: {
    overview: 'Übersicht',
    account: 'Kontoeinstellungen',
    dataPrivacy: 'Daten & Datenschutz',
    security: 'Sicherheit',
    profileManagement: 'Profilverwaltung',
    helpSupport: 'Hilfe & Support',
    myProfile: 'Mein Profil',
    gallery: 'Galerie',
    myPreferences: 'Mein Feed',
    myLikes: 'Meine Likes',
    logout: 'Abmelden',
  },
},

// SidebarVisitor
sidebarVisitor: {
  headers: {
    postsBy: 'Beiträge von:',
    chat: 'Chat',
    mainNav: 'Hauptnavigation',
    profileActions: 'Profilaktionen',
  },

  labels: {
    userFallback: 'Benutzer',
    thisUser: 'diesem Benutzer',
  },

  buttons: {
    chatWithName: 'Mit {{name}} chatten',
    chatShort: 'Chat',
    backToGallery: '🖼 Galerie',
    following: 'Abonniert',
    favorites: 'Mein Feed',
    followers: 'Meine Follower',
    follow: 'Ich folge...',
    unfollow: 'Entfolgen',
    block: 'Blockieren',
    unblock: 'Blockierung aufheben',
    blockAndReport: 'Blockieren & melden',
  },

  tooltips: {
    chatWith: 'Mit {{name}} chatten',
  },

  confirm: {
    block:
      '{{name}} blockieren? Diese Person kann nicht mehr mit dir interagieren und ihr könnt die Beiträge oder Nachrichten des jeweils anderen nicht mehr sehen.',
  },

  alerts: {
    actionFailed: 'Aktion fehlgeschlagen',
    blockSuccess: 'Benutzer wurde blockiert.',
    blockError: 'Blockieren fehlgeschlagen',
    unblockSuccess: 'Blockierung des Benutzers aufgehoben.',
    unblockError: 'Aufheben der Blockierung fehlgeschlagen',
  },
},

// SidebarChat
sidebarChat: {
  actions: {
    backToGallery: 'Zur Galerie',
  },

  search: {
    placeholder: 'Benutzer nach Profilnamen suchen…',
  },

  list: {
    activeTitle: 'Aktive Chats',
  },

  preview: {
    image: 'Foto',
    video: 'Video',
    audio: 'Audio',
    media: 'Medien',
  },

  unreadLabel: '{{count}} ungelesen',

  menu: {
    moreOptionsAria: 'Weitere Optionen',
    moreOptionsTitle: 'Weitere Optionen',
    hideChat: 'Chat ausblenden',
    deleteChat: 'Chat löschen',
  },
},

} as const;
  
  export default sidebars;
  